const initialState = {}

export default (state = initialState, action) => {
  const { type } = action
  const matches = /(.*)_(REQUEST|SUCCESS|RESET)/.exec(type)

  if (!matches) return state

  const [, requestName, requestState] = matches

  return {
    ...state,
    [requestName]: requestState === 'SUCCESS',
  }
}
